import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { JudicialRecordsContext } from "./JudicialRecordsContext";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';
import { detailJudicialRecords } from "services/JudicialRecordsService";
import ReactJson from "react-json-view";
import { Button } from "primereact/button";

const ModalView = () => {
    //! define

    //! state
    const toast = useRef(null);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;
    const { t, i18n } = useTranslation(["judicial-records", "common"]);

    const judicialContext = useContext(JudicialRecordsContext);

    const { openDialogView, setOpenDialogView, setLoading } = judicialContext;

    const [jsonViewer, setJsonViewer] = useState({
        request: "",
        response: "",
    });

    //! function
    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const getDetailJudicialRecord = (type) => {
        setLoading(true);

        detailJudicialRecords(headers, openDialogView)
            .then((res) => {
                if (res.status === 200) {
                    setJsonViewer({
                        request: res.data.request,
                        response: res.data.response,
                    });
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    //! useEffect
    useEffect(() => {
        if (openDialogView) {
            getDetailJudicialRecord();
        }
    }, [openDialogView]);

    //! render
    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={!!openDialogView} style={{ width: "70%" }} header={t("judicial-records.detail").toUpperCase()} modal className="p-fluid text-center" onHide={() => setOpenDialogView(null)}>
                <div>
                    <div style={{ textAlign: "left", fontWeight: 700, marginBottom: "10px", display: "flex", alignItems: "center" }}>
                        <i className="pi pi-sign-in" style={{ marginRight: "10px" }}></i>
                        {t("judicial-records.request").toUpperCase()}
                    </div>
                    <ReactJson src={jsonViewer?.request && JSON.parse(jsonViewer?.request)} style={{ textAlign: "left", background: "#f5f5f5", padding: "10px", borderRadius: "6px" }} />
                </div>
                <div></div>
                <div>
                    <div style={{ textAlign: "left", fontWeight: 700, margin: "10px 0", display: "flex", alignItems: "center" }}>
                        <i className="pi pi-sign-out" style={{ marginRight: "10px" }}></i>
                        {t("judicial-records.response").toUpperCase()}
                    </div>
                    <ReactJson src={jsonViewer?.request && JSON.parse(jsonViewer?.response)} style={{ textAlign: "left", background: "#f5f5f5", padding: "10px", borderRadius: "6px" }} />
                </div>
            </Dialog>
        </>
    );
};

export default ModalView;
